import { ApiFailure, isNetworkFailure } from '../../api/client';
import type { T } from '../../i18n';

/** Translate any thrown error (API code, network failure, unknown) into a user-facing sentence. */
export function errorText(t: T, e: unknown): string {
  if (e instanceof ApiFailure) return t(`error.${e.code}`);
  if (isNetworkFailure(e)) return t('error.network');
  return t('common.error');
}

/** Field paths from a 422 `validation` error (zod issues: [{ path: ['phone'], … }]). */
export function invalidFields(e: unknown): Set<string> {
  const out = new Set<string>();
  if (!(e instanceof ApiFailure) || e.code !== 'validation' || !Array.isArray(e.details)) return out;
  for (const issue of e.details as { path?: unknown }[]) {
    const first = Array.isArray(issue?.path) ? issue.path[0] : undefined;
    if (typeof first === 'string') out.add(first);
  }
  return out;
}
